import React, { useEffect, useState } from "react";
import "./LineProgressBar.css";

const LineProgressBar = ({ progress, autoProgress = false, intervalDuration = 500, handler, infinite }) => {
  const [internalProgress, setInternalProgress] = useState(0);

  useEffect(() => {
    let interval;
    if (autoProgress && progress === undefined) {
      interval = setInterval(() => {
        setInternalProgress((oldProgress) => {
          if (oldProgress < 100) return oldProgress + 5;

          handler();
          clearInterval(interval);
          return 100;
        });
      }, intervalDuration);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [autoProgress, intervalDuration, progress]);

  const currentProgress = progress !== undefined ? progress : internalProgress;

  return (
    <div className="line-progress-bar w-240">
      <span className={`line-loading ${infinite ? "infinite" : ""}`} style={{ width: `${infinite ? 30 : currentProgress}%` }} />
    </div>
  );
};

export default LineProgressBar;
